<template>
  <!--
      作者：luoyiming
      时间：2019-10-24
      描述：服务管理
  -->
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="项目名称">
          <el-input size="small" v-model="searchForm.productName" placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item label="项目分类">
          <el-select size="small" v-model="searchForm.categoryId" placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name"
              :value="item.categoryId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务类型">
          <el-select size="small" v-model="searchForm.serviceId" placeholder="服务类型">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in serviceList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目类型">
          <el-select size="small" v-model="searchForm.serviceCategory" placeholder="项目类型">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in serviceCategory" :key="index" :label="item.value"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="所属商户">
          <el-select size="small" v-model="searchForm.shopSupplierId" placeholder="所属商户">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in supplierList" :key="index" :label="item.name" :value="item.shopSupplierId"></el-option>
          </el-select>
        </el-form-item> -->

        <!-- <el-form-item label="是否加钟">
          <el-select size="small" v-model="searchForm.isClock" placeholder="请选择是否加钟">
            <el-option label="全部" value=""></el-option>
            <el-option label="正常服务" value="0"></el-option>
            <el-option label="加钟服务" value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="是否上架">
          <el-select size="small" v-model="searchForm.productStatus" placeholder="请选择是否上架">
            <el-option label="全部" value="0"></el-option>
            <el-option label="上架" value="10"></el-option>
            <el-option label="下架" value="20"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus"
        v-auth="'/product/product/add'">添加项目</el-button>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="productId" align="center" label="项目ID" width="60"></el-table-column>
          <!-- <el-table-column prop="productName" label="项目图">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image[0].filePath" alt="" /></div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="productName" align="center" label="项目名称" width="130"></el-table-column>
          <el-table-column prop="productName" align="center" label="项目图" width="130">
            <template slot-scope="scope">
              <div class="product-info">
                <preview-image style="width:100%;height:100%" :srcUrl="scope.row.imagePath"
                  v-if="scope.row.imagePath"> </preview-image>
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="supplier.name" label="商户名称"></el-table-column> -->
          <el-table-column prop="service.name" align="center" label="服务类型" width="130">
          
          </el-table-column>
          <el-table-column  align="center" label="项目类型" width="130">
              <template slot-scope="scope">
              <div>{{ scope.row.serviceCategory==1?'推荐项目':'调理项目'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="service.name" align="center" label="项目分类" width="130">
			  <template slot-scope="scope">
			    <span>{{ scope.row.category?scope.row.category.name:'' }}</span>
			  </template>
		  </el-table-column>
          <el-table-column prop="productPrice" align="center" label="项目售价" width="130">
            <template slot-scope="scope">
              <span style="color:red">￥ {{ scope.row.productPrice ? scope.row.productPrice : 0.00 }} 元</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="isClock" align="center" label="是否加钟" width="130">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isClock == 0">正常服务</el-tag>
              <el-tag v-if="scope.row.isClock == 1" type="danger">加钟服务</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column prop="salesActual" align="center" label="销量" width="130"></el-table-column>
          <el-table-column prop="serviceTime" align="center" label="服务时间(分钟)" width="130"></el-table-column>
          <el-table-column prop="productSort" align="center" label="排序" width="130"></el-table-column>
          <el-table-column prop="productStatus" label="状态" align="center" >
            <template slot-scope="scope">
              <el-switch class="switch" @change='projectstate(scope.row)' v-model="scope.row.productStatus"
                :active-value="10" :inactive-value="20" active-text="上架" inactive-text="下架">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" align="center" label="发布时间" width="140"></el-table-column>
          <el-table-column fixed="right" align="center" label="操作" >
            <template slot-scope="scope">
              <!-- <el-button @click="obClick(scope.row)" type="info" size="small"
                >查看代理价格</el-button> -->
              <el-button @click="editClick(scope.row)" type="primary" size="small"
                v-auth="'/product/product/edit'">编辑</el-button>
              <el-button @click="delClick(scope.row)" type="danger" size="small"
                v-auth="'/product/product/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
        :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import PorductApi from "@/api/product.js";
export default {
  data() {
    return {
      showViewer: false, // 显示查看器
      /*切换菜单*/
      activeName: "",
      /*切换选中值*/
      activeIndex: "0",
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        productName: "",
        serviceId: "",
        isClock: "",
        categoryId: "",
        shopSupplierId: "",
        productStatus: "",
        serviceCategory: ''
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      serviceList: [],
      serviceCategory: [],
      supplierList: [],
      /*服务统计*/
      product_count: {}
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    projectstate(row) {
      let self = this;
      PorductApi.projectstate({
        productId: row.productId,
        state: row.productStatus
      }).then(data => {
        self.$message({
          message: "修改成功",
          type: "success"
        });
        self.getData();
      });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      Params.type = self.activeName;
      self.loading = true;
      PorductApi.productList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.productList.data;
          console.log(self.tableData,'我的列表数据')
          self.categoryList = data.data.category;
          self.serviceList = data.data.serviceList;
          self.serviceCategory = data.data.serviceCategory || [];
          // if (data.data.serviceCategory) {
          //   self.tableData.forEach(tableItem => {
          //     self.serviceCategory.forEach(categoryItem => {
          //       if (tableItem.serviceCategory == categoryItem.id) {
          //         tableItem.serviceCategory = categoryItem.value;
          //       }
          //     });
          //   });
          // }
          self.supplierList = data.data.supplierList;
          // self.productIds = data.data.productIds;
          self.totalDataNumber = data.data.productList.total;
          // self.product_count = data.data.product_count;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
    addClick(row) {
      this.$router.push("/product/product/add");
    },
    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: "/product/product/edit",
        query: {
          productId: row.productId,
          scene: "edit"
        }
      });
    },
    obClick(row){
      this.$router.push({
        path: "/product/product/newprice",
        query: {
          productId: row.productId,
        }
      });
    },
    /*删除*/
    delClick: function (row) {
      let self = this;
      self
        .$confirm("删除后将移动到回收站，确定删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          PorductApi.delProduct({
            productId: row.productId
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>
<style lang="scss">
.product-list {

  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }

  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }

  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-right: 15px;
  }

  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }

  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 9px;
  }

  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }

  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 50px !important;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/index.vue